export const UPLOAD_REQUEST = '@upload/UPLOAD_REQUEST';
export const UPLOAD_SUCCESS = '@upload/UPLOAD_SUCCESS';
export const UPLOAD_FAILURE = '@upload/UPLOAD_FAILURE';
